import { resume } from '../../data/resume';
import SectionHeading from '../layout/SectionHeading';

/**
 * Experience section: each entry is a card with a thick colored "spine"
 * (rotating between muted accents per entry), the role in Antonio display,
 * the company in a script flourish, the period in a small bordered tag,
 * and bullets as serif paragraphs with a colored dot marker.
 */
const SPINES = [
  { bg: 'bg-accent-oxblood', dot: 'bg-accent-oxblood' },
  { bg: 'bg-accent-dustyBlue', dot: 'bg-accent-dustyBlue' },
  { bg: 'bg-accent-olive', dot: 'bg-accent-olive' },
  { bg: 'bg-accent-mustard', dot: 'bg-accent-mustard' },
];

const Experience = () => (
  <section className="border-b-[3px] border-ink bg-paper-warm px-8 py-10">
    <SectionHeading kana="経歴" accent="text-accent-dustyBlue">
      Experience
    </SectionHeading>

    <div className="space-y-6">
      {resume.experience.map((entry, i) => {
        const spine = SPINES[i % SPINES.length];
        const num = String(i + 1).padStart(2, '0');
        return (
          <article
            key={`${entry.company}-${entry.role}`}
            className="relative grid grid-cols-[10px_1fr] overflow-hidden border-[3px] border-ink bg-paper-base shadow-sleeveSm"
          >
            <div aria-hidden className={`${spine.bg} h-full w-[10px]`} />

            <div className="px-6 py-5">
              <div className="flex flex-wrap items-end justify-between gap-3">
                <div>
                  <div className="font-mono text-[0.65rem] font-bold uppercase tracking-retro text-ink-muted">
                    Nº {num}
                  </div>
                  <h3 className="font-display text-3xl font-bold uppercase leading-none tracking-retro text-ink">
                    {entry.role}
                  </h3>
                  <div className="font-script text-3xl leading-none text-accent-oxblood">
                    {entry.company}
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-mono text-[0.65rem] font-bold uppercase tracking-retro text-ink-muted">
                    Period
                  </div>
                  <div className="border-2 border-ink bg-paper-warm px-2 py-0.5 font-mono text-xs font-bold uppercase tracking-retro text-ink">
                    {entry.period}
                  </div>
                </div>
              </div>

              <ul className="mt-4 space-y-2">
                {entry.bullets.map((bullet) => (
                  <li key={bullet} className="flex gap-3 font-serif text-base leading-relaxed text-ink">
                    <span aria-hidden className={`mt-2 inline-block h-2 w-2 shrink-0 ${spine.dot}`} />
                    <span>{bullet}</span>
                  </li>
                ))}
              </ul>
            </div>
          </article>
        );
      })}
    </div>
  </section>
);

export default Experience;
